module.exports = __webpack_public_path__ + "static/media/prd-cat-md-3.c0a841ac.jpeg";